import { render, staticRenderFns } from "./svg.vue?vue&type=template&id=3e8ddb44"
import script from "./svg.vue?vue&type=script&lang=js"
export * from "./svg.vue?vue&type=script&lang=js"
import style0 from "./svg.vue?vue&type=style&index=0&id=3e8ddb44&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports